import { Component, Input } from '@angular/core';

export type SeFloatingLabelState = 'active' | 'error' | 'warning' | 'disabled';

@Component({
    selector: 'se-floating-label',
    templateUrl: './se-floating-label.component.html',
    styleUrls: ['./se-floating-label.component.scss'],
    standalone: false
})
export class SeFloatingLabelComponent {
    @Input()
    for: string;

    @Input()
    state: SeFloatingLabelState;

    @Input()
    tooltip?: string;

    @Input()
    materialStyle: boolean = false;
}
